export const GET_DOCUMENTS_SUCCESS = 'GET_DOCUMENTS_SUCCESS';